var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ABABAB",
    fillRule: "evenodd",
    d: "M8.667 10.667a.667.667 0 0 1-1.334 0V7.333a.667.667 0 0 1 1.334 0v3.334Zm0-5.334a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0ZM8 2.667A5.34 5.34 0 0 1 13.333 8 5.34 5.34 0 0 1 8 13.333 5.34 5.34 0 0 1 2.667 8 5.34 5.34 0 0 1 8 2.667Zm0 12A6.666 6.666 0 1 0 8 1.334a6.666 6.666 0 0 0 0 13.333Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.6d43be0073eaa86d6c247cdb4ff9e57f.svg";
export { ForwardRef as ReactComponent };